/** The Parlyst mark and wordmark (shared by the app shell and the sign-in screen). */
/** The P-with-bottle mark, for places where only a small symbol fits. */
export function Mark({ tone = "green", label }: { tone?: "green" | "cream"; label?: string }) {
  return (
    <img
      className="brand-mark"
      src={`/brand/parlyst-mark-${tone}.svg`}
      alt={label ?? ""}
      aria-hidden={label ? undefined : true}
    />
  );
}
/** The Parlyst wordmark: green on cream, cream on the green panels. */
export function Wordmark({ tone = "green" }: { tone?: "green" | "cream" }) {
  return <img className="brand-wordmark" src={`/brand/parlyst-wordmark-${tone}.svg`} alt="Parlyst" />;
}
